import { ActivityPurchaseModel } from 'api-hooks/order/activity';
import { ChevronDown } from 'baseui/icon';
import { CloseSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Form, FormState, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import Text from 'components/elements/text';
import { SeparatorHorizontal } from 'components/styles';
import useDrawer from 'hooks/use-drawer';
import { ButtonContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../../style';
import { ActivityPurchaseFormType } from '../form-type';

interface Props {
  activityPurchases?: ActivityPurchaseModel;
}

export default function SummaryActivityPurchase(props: Props) {
  const { t } = useTranslation();
  const { activityPurchases } = props;
  const methods = useFormContext<ActivityPurchaseFormType>();

  const {
    formState: { isSubmitting },
    reset,
    clearErrors,
  } = methods;

  const drawer = useDrawer();

  const { total } = useRecalculate();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (close) => (
        <Form methods={methods} onSubmit={() => {}}>
          <SummaryDrawer onClose={close} />
        </Form>
      ),
    });
  }, [drawer, methods]);

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_order')}
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}>
          {`Rp. ${string2money(total)}`}
        </Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <FormState>
        {({ editable, setIsEditable }) => (
          <SummaryRightContainer>
            {editable && activityPurchases && !isSubmitting && (
              <>
                <ButtonContainer style={{ marginLeft: '16px' }}>
                  <Button
                    buttonType="secondary"
                    startEnhancer={(color, size) => (
                      <CloseSVG width={size} height={size} color={color} />
                    )}
                    onClick={() => {
                      clearErrors();
                      reset();
                      setIsEditable(false);
                    }}
                  >
                    {t('common:cancel')}
                  </Button>
                </ButtonContainer>
              </>
            )}
            <Input
              type="submit"
              overrides={{
                Root: {
                  style: {
                    flex: 1,
                  },
                },
              }}
            />
          </SummaryRightContainer>
        )}
      </FormState>
    </SummaryContent>
  );
}
